import React, { memo } from 'react';
import { ListItemButton, ListItemText, Collapse, Box, Switch } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import TooltipHelpButton from '../buttons/TooltipHelpButton/TooltipHelpButton';
import WarningButton from '../buttons/WarningButton';

const styles = theme => ({
    item: {
        background: theme.palette.action.hover,
    },
    collapse: {
        backgroundColor: theme.palette.background.paperDark
    }
});

const CollapsibleSwitchListItem = ({
    classes,
    children,
    checked,
    text,
    toolTip,
    warning,
    onChange,
    expansionEnabled = true,
    disabled = false,
    ...other
}) => {
    const expanded = expansionEnabled && checked;

    return (
        <>
            <ListItemButton
                {...other}
                aria-expanded={expanded}
                className={expanded ? classes.item : null}
                onClick={disabled ? undefined : () => onChange(!checked)}
            >
                <ListItemText>
                    {text}
                    {toolTip && <TooltipHelpButton title={toolTip} />}
                    {warning && <WarningButton title={warning} />}
                </ListItemText>
                <Box onClick={(e) => e.stopPropagation()}>
                    <Switch
                        checked={checked}
                        onChange={(event) => onChange(event.target.checked)}
                        color="primary"
                        disabled={disabled}
                    />
                </Box>
            </ListItemButton>
            <Collapse in={expanded} timeout="auto" unmountOnExit className={classes.collapse}>
                {children}
            </Collapse>
        </>
    );
};

export default memo(withStyles(CollapsibleSwitchListItem, styles));